<!-- 查询车场账单信息 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN6112",
                "dimension": "2",
                "startTime": "2019-08-17 00:00:00",
                "endTime": "2019-08-17 23:59:59",
                "pageNum": "1",
                "pageSize": "10"
            },
            responseCode: {
                "data": {
                    "aliRealValue": 0,
                    "cashRealValue": 0,
                    "couponValue": 1042.79,
                    "currCount": 1,
                    "integralReliefValue": 36.82,
                    "otherRealValue": 0,
                    "parkOnlineReliefValue": 289.2,
                    "parkReliefValue": 0,
                    "platformIntegralReliefValue": 90.61,
                    "platformReliefValue": 118.36,
                    "realValue": 49670.02,
                    "recordList": [
                        {
                            "aliRealValue": 0.06,
                            "cashRealValue": 48448.06,
                            "couponValue": 1042.79,
                            "integralReliefValue": 36.82,
                            "otherList": [
                                {
                                    "chargeNum": 23,
                                    "parkId": "f034cc92-1680-4be6-9026-c174496ea7df",
                                    "realValue": 70.21,
                                    "reliefValue": 7.21,
                                    "shouldValue": 73.39,
                                    "statDim": "2019",
                                    "type": 0,
                                    "typeName": "未知"
                                },
                                {
                                    "chargeNum": 40,
                                    "parkId": "f034cc92-1680-4be6-9026-c174496ea7df",
                                    "realValue": 1009.88,
                                    "reliefValue": 508.06,
                                    "shouldValue": 1517.94,
                                    "statDim": "2019",
                                    "type": 9,
                                    "typeName": "账户余额"
                                },
                                {
                                    "chargeNum": 13,
                                    "parkId": "f034cc92-1680-4be6-9026-c174496ea7df",
                                    "realValue": 85.5,
                                    "reliefValue": 22.5,
                                    "shouldValue": 108,
                                    "statDim": "2019",
                                    "type": 12,
                                    "typeName": "第三方余额"
                                }
                            ],
                            "otherRealValue": 1165.59,
                            "parkId": "f034cc92-1680-4be6-9026-c174496ea7df",
                            "parkName": "云开发测试车场",
                            "parkOnlineReliefValue": 289.2,
                            "parkReliefValue": 0,
                            "platformIntegralReliefValue": 90.61,
                            "platformReliefValue": 118.36,
                            "realValue": 49670.02,
                            "shouldValue": 50712.81,
                            "statDim": "2019",
                            "thirdReliefForYdtoPayParkFeeValue": 0,
                            "thirdReliefValue": 5.06,
                            "traderReliefValue": 290.71,
                            "weixinRealValue": 56.31
                        }
                    ],
                    "shouldValue": 50712.81,
                    "thirdReliefForYdtoPayParkFeeValue": 0,
                    "thirdReliefValue": 5.06,
                    "total": 1,
                    "traderReliefValue": 290.71,
                    "weixinRealValue": 0
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询某车场账单汇总信息",
                t_url: this.commonUrls.test+"getParkBill",
                p_url: this.commonUrls.prod+"getParkBill",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
               Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'dimension', info2: '是', info3: 'Integer', info4: '时间维度: 0天, 1月, 2年' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间（仅识别到日，时分秒将被忽略），yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间（仅识别到日，时分秒将被忽略），yyyy-MM-dd HH:mm:ss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'shouldValue', info2: '是', info3: 'Decimal', info4: '总业务应收金额' },
                        { info1: 'realValue', info2: '是', info3: 'Decimal', info4: '总实收总额，包含现金、微信、支付宝及其他实收金额' },
                        { info1: 'cashRealValue', info2: '否', info3: 'Decimal', info4: '总现金' },
                        { info1: 'weixinRealValue', info2: '是', info3: 'Decimal', info4: '总微信支付金额' },
                        { info1: 'aliRealValue', info2: '是', info3: 'Decimal', info4: '总支付宝支付金额' },
                        { info1: 'otherRealValue', info2: '是', info3: 'Decimal', info4: '总其他实收金额' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '总优惠金额(注意与reportParkingFee中各类优惠描述对应)，包括车场本地优惠、电子优惠券优惠、停车场线上活动优惠、第三方积分抵扣金额、第三方优惠金额（ydto缴费）、第三方优惠、城市运营券优惠、城市运营积分抵扣优惠' },
                        { info1: 'parkReliefValue', info2: '是', info3: 'Decimal', info4: '总车场本地优惠' },
                        { info1: 'traderReliefValue', info2: '是', info3: 'Decimal', info4: '总电子优惠券优惠' },
                        { info1: 'parkOnlineReliefValue', info2: '是', info3: 'Decimal', info4: '总停车场线上活动优惠' },
                        { info1: 'integralReliefValue', info2: '是', info3: 'Decimal', info4: '总第三方积分抵扣金额' },
                        { info1: 'thirdReliefForYdtoPayParkFeeValue', info2: '是', info3: 'Decimal', info4: '总第三方优惠金额（ydto缴费）' },
                        { info1: 'thirdReliefValue', info2: '是', info3: 'Decimal', info4: '总第三方优惠' },
                        { info1: 'platformReliefValue', info2: '是', info3: 'Decimal', info4: '总城市运营券优惠' },
                        { info1: 'platformIntegralReliefValue', info2: '是', info3: 'Decimal', info4: '总城市运营积分抵扣优惠' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '停车场uuid' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'statDim', info2: '否', info3: 'String', info4: '统计日期，日时间维度：yyyy-MM-dd，月时间维度：yyyy-MM，年时间维度：yyyy' },
                        { info1: 'shouldValue', info2: '是', info3: 'Decimal', info4: '业务应收金额' },
                        { info1: 'realValue', info2: '是', info3: 'Decimal', info4: '实收总额，包含现金、微信、支付宝及其他实收金额' },
                        { info1: 'cashRealValue', info2: '否', info3: 'Decimal', info4: '现金' },
                        { info1: 'weixinRealValue', info2: '是', info3: 'Decimal', info4: '微信支付金额' },
                        { info1: 'aliRealValue', info2: '是', info3: 'Decimal', info4: '支付宝支付金额' },
                        { info1: 'otherRealValue', info2: '是', info3: 'Decimal', info4: '其他实收金额' },
                        { info1: 'otherList', info2: '是', info3: 'JSONObject', info4: '其他实收明细' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '优惠金额，包括车场本地优惠、电子优惠券优惠、停车场线上活动优惠、第三方积分抵扣金额、第三方优惠金额（ydto缴费）、第三方优惠、城市运营券优惠、城市运营积分抵扣优惠' },
                        { info1: 'parkReliefValue', info2: '是', info3: 'Decimal', info4: '车场本地优惠' },
                        { info1: 'traderReliefValue', info2: '是', info3: 'Decimal', info4: '电子优惠券优惠' },
                        { info1: 'parkOnlineReliefValue', info2: '是', info3: 'Decimal', info4: '停车场线上活动优惠' },
                        { info1: 'integralReliefValue', info2: '是', info3: 'Decimal', info4: '第三方积分抵扣金额' },
                        { info1: 'thirdReliefForYdtoPayParkFeeValue', info2: '是', info3: 'Decimal', info4: '第三方优惠金额（ydto缴费）' },
                        { info1: 'thirdReliefValue', info2: '是', info3: 'Decimal', info4: '第三方优惠' },
                        { info1: 'platformReliefValue', info2: '是', info3: 'Decimal', info4: '城市运营券优惠' },
                        { info1: 'platformIntegralReliefValue', info2: '是', info3: 'Decimal', info4: '城市运营积分抵扣优惠' },
                        ]
                },{
                    titleName: 'otherList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'chargeNum', info2: '是', info3: 'String', info4: '缴费账单序号' },
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '停车场uuid' },
                        { info1: 'realValue', info2: '否', info3: 'Decimal', info4: '实缴' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '优惠' },
                        { info1: 'shouldValue', info2: '是', info3: 'Decimal', info4: '应缴' },
                        { info1: 'statDim', info2: '是', info3: 'String', info4: '统计日期，日时间维度：yyyy-MM-dd，月时间维度：yyyy-MM，年时间维度：yyyy' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '类型' },
                        { info1: 'typeName', info2: '是', info3: 'String', info4: '类型名称' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/dataAnalysis/getParkBill.vue